import { get, sortBy, pick, omit } from 'lodash';
import * as R from 'ramda';
import { SHOP_CURRENCY, SHOP_TYPE } from '../../main/shops/constants';
import getLanguageOptionsByCodes from '../../common/LanguageMultiSelect/getLanguageOptionsByCodes';

export const getInitialValuesFromBrand = (brand) => {
  if (!brand || !brand.shops) {
    return {
      settings: {
        supportedLanguages: getLanguageOptionsByCodes(),
      },
    };
  }

  const supportedLanguages = getLanguageOptionsByCodes(brand.settings && brand.settings.supportedLanguages);
  const brandDefaultLanguage = brand.settings && brand.settings.defaultLanguage;
  const offerInstantPayout = get(brand, ['settings', 'offerInstantPayout']);

  return {
    ...omit(brand, ['address']),
    settings: {
      ...brand.settings,
      supportedLanguages,
      defaultLanguage: supportedLanguages.find(({ value }) => value === brandDefaultLanguage),
      ecommerceSyncIntegration: get(brand, ['settings', 'ecommerceSyncIntegration']) || false,
      mailchimpIntegrationEnabled: get(brand, ['settings', 'mailchimpIntegrationEnabled']) || false,
      membershipsEnabled: get(brand, ['settings', 'membershipsEnabled']) || false,
      itemizedChargeDisplayEnabled: get(brand, ['settings', 'itemizedChargeDisplayEnabled']) || false,
      displayReservationAds: get(brand, ['settings', 'displayReservationAds']) || false,
      offerInstantPayout: (offerInstantPayout || offerInstantPayout === 0) ? offerInstantPayout : null,
    },
    brandShops: sortBy(brand.shops.map(shop =>
      (
      {
        shopId: shop.id,
        ...pick(
          shop,
          [
            'bankAccountId',
            'shopOrder',
            'showOnBrandPage',
            'showOnCustomApp',
            'shareGiftCards',
            'overrideBookingLink',
            'name',
            'brandId',
            'kind',
          ]
        ),
      }
      ),
    ), ['shopOrder']),
  };
};

export const getEmptyInitialValues = () => ({
  website: '',
  instagram: '',
  description: '',
  currency: SHOP_CURRENCY.usd,
  settings: {
    supportedLanguages: getLanguageOptionsByCodes(),
    defaultLanguage: getLanguageOptionsByCodes()[0],
    ecommerceSyncIntegration: false,
    mailchimpIntegrationEnabled: false,
    membershipsEnabled: false,
    offerInstantPayout: null,
  },
});

export const resolveSeries = async (promises) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const promise of promises) {
    // eslint-disable-next-line no-await-in-loop
    await promise;
  }
};

const prepareDefaultLanguage = R.over(R.lensPath(['settings', 'defaultLanguage']), ({ value }) => value);
const prepareSupportedLanguage = R.over(R.lensPath(['settings', 'supportedLanguages']), R.map(({ value }) => value));
export const preparePrimaryAccountOwner =
  R.over(
    R.lensPath(['settings', 'primaryAccountOwner']),
    owner => (owner && typeof owner === 'object' ? owner.value : owner || null)
  );

export const prepareLanguageSettings = R.compose(
  prepareDefaultLanguage,
  prepareSupportedLanguage,
);

export const isShopWithoutPaymentInfoSetup = shop => shop.kind === SHOP_TYPE.commission && !shop.bankAccountId;
